import { render, staticRenderFns } from "./LtiConnect.vue?vue&type=template&id=81689e70"
import script from "./LtiConnect.vue?vue&type=script&lang=js"
export * from "./LtiConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports